import { render, staticRenderFns } from "./ShoppingCartItem.vue?vue&type=template&id=5d15cbc9&scoped=true&"
import script from "./ShoppingCartItem.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartItem.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartItem.vue?vue&type=style&index=0&id=5d15cbc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d15cbc9",
  null
  
)

export default component.exports